import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import { DetailHeader } from "../../../common/components/DetailHeader";
import { readSearchReturn } from "../../../common/searchNavigation";
import { visuallyHidden } from "../../../common/visuallyHidden";
import { KioskCodeEntry } from "./KioskCodeEntry";

/**
 * The check-in screen's one-row header ("Drop-in" with the facility), its task
 * h1 for assistive tech, and the one-line explanation. The back arrow returns
 * to a valid Search origin, else the facility, and is withheld while a payment
 * is in flight so the check-in or card save settles first. Below it, a
 * player who holds a pass or membership is offered a code for the entrance
 * kiosk instead.
 */
export function DropInCheckInHeader({
  facilityId,
  facilityName,
  paymentInFlight,
  isSelfServe,
}: {
  facilityId: string;
  facilityName?: string;
  paymentInFlight: boolean;
  isSelfServe: boolean;
}) {
  const searchReturn = readSearchReturn(useLocation().search);
  return (
    <Box>
      <DetailHeader
        title="Drop-in"
        titleComponent="p"
        subtitle={facilityName || undefined}
        back={
          paymentInFlight
            ? undefined
            : searchReturn
              ? { to: searchReturn, label: "Back to search" }
              : { to: `/facility/${facilityId}`, label: "Back to facility" }
        }
      />
      <Typography component="h1" sx={visuallyHidden}>
        Check yourself in
      </Typography>
      <Typography color="text.secondary" variant="body2" sx={{ mt: 1.5 }}>
        Pay for your own spot and accept your waiver, then{" "}
        {isSelfServe ? "pick a court" : "join the court queue"}. Friends each
        check in on their own device.
      </Typography>
      <KioskCodeEntry facilityId={facilityId} />
    </Box>
  );
}
